import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';
import { withRouter } from 'react-router-dom';
import {
	setPageHeaderTextActionCreator,
} from 'plugins/store/reducers/common.reducer';
import { scrollToTop } from 'utils/utils';
import withEvents from 'eventBus/withEvents';
import eventBusTypes from 'eventBus/eventBusTypes';

import { setNumberRowsPerPageActionCreator } from 'plugins/store/reducers/settings.reducer';
import { getAlerts, markAlert } from 'services/alerts.service';

// @material-ui
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import withStyles from '@material-ui/core/styles/withStyles';
import RefreshIcon from '@material-ui/icons/Refresh';

// core components
import Pagination from 'components/Pagination/Pagination';
import PageSizeSelect from 'components/PageSizeSelect/PageSizeSelect';
import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';
import Card from 'components/Card/Card';
import CardBody from 'components/Card/CardBody';
import CardHeader from 'components/Card/CardHeader';
import CardIcon from 'components/Card/CardIcon';
import LoadingIndicator from 'components/LoadingIndicator/LoadingIndicator';
import Button from 'components/CustomButtons/Button';

import AlertsItem from './AlertsItem';

const styles = {
	preloader: {
		position: 'absolute',
		left: '50%',
		top: '50%',
		transform: 'translate(-50%, -50%)',
	},
	header: {
		position: 'absolute',
		top: '-3rem',
		left: 0,
		padding: '0 20px',
		zIndex: 20,
	},
	body: {
		minHeight: 300,
		position: 'relative',
	},
	refreshButton: {
		padding: 0,
	},
	emptyMessage: {
		position: 'absolute',
		top: '50%',
		textAlign: 'center',
		left: '50%',
		fontSize: '16px',
		color: '#999',
		transform: 'translate(-50%, -50%)',
	},
}

class Alerts extends React.Component {
	viewName = 'Notifications';

	state = {
		items: [],
		pageCount: 0,
		pageIndex: 1,
		totalRecordsCount: 0,
		loading: false,
		markAlertCallback: null,
	};

	componentDidMount() {
		this.fetchData();
		this.props.setPageHeaderText(this.viewName);
		const markAlertCallback = this.props.EventBus.addEventListener(
			eventBusTypes.MARK_ALERT,
			({ id, isRead }) => {
				this.setNewStatusToItem(id, isRead)
			},
		);
		this.setState({ markAlertCallback });
	}

	componentWillUnmount() {
		this.props.setPageHeaderText('');
		this.props.EventBus.removeEventListener(eventBusTypes.MARK_ALERT, this.state.markAlertCallback);
	}

	paginationHandler = async (event, pageIndex) => {
		this.setState({ pageIndex }, this.fetchData);
	}

	setRowsPerPage = async (pageSize) => {
		await this.props.setRowsPerPage({
			table: 'alerts',
			rowsPerPage: pageSize
		});
		this.setState({ pageIndex: 1 }, this.fetchData);
	}

	fetchData = async () => {
		try {
			scrollToTop();
			this.setState({ loading: true });

			const pageIndex = this.state.pageIndex - 1;
			const pageSize = this.props.rowsPerPage;
			const { userId } = this.props;

			const { data, dataLength } = await getAlerts({ pageIndex, pageSize, userId });

			this.setState({
				items: data,
				totalRecordsCount: dataLength,
				pageCount: Math.ceil(dataLength / this.props.rowsPerPage),
			});
		} catch (error) {
			console.log(error);
		}
		this.setState({ loading: false });
	}

	markAlert = async (id, isRead) => {
		this.setAlertLoadingStatus(id, true);
		try {
			await markAlert(id, isRead);
			this.props.EventBus.dispatchEvent({
				type: eventBusTypes.MARK_ALERT,
				payload: { id, isRead, fromAlertPage: true },
			});
		} catch (error) {
			console.log(error);
		}
		this.setAlertLoadingStatus(id, false);
	}

	setNewStatusToItem = (id, isRead) => {
		const items = this.state.items.map((item) => {
			if (item.id === id) {
				item.isRead = isRead;
			}
			return item;
		});

		this.setState({ items });
	}

	setAlertLoadingStatus = (id, isLoading) => {
		const items = this.state.items.map((item) => {
			if (item.id === id) {
				item.isLoading = isLoading;
			}
			return item;
		});

		this.setState({ items });
	}

	render() {
		const preloader = this.state.loading
			? <div className={this.props.classes.preloader}><LoadingIndicator /></div>
			: null;

		const emptyMessage = this.state.totalRecordsCount === 0 && !this.state.loading
			? <div className={this.props.classes.emptyMessage}>You do not have any unread notifications</div>
			: null;

		return (
			<GridContainer>
				<GridItem xs={12} sm={12} md={12}>
					<Card>
						<CardHeader color="primary" icon>
							<CardIcon color="primary">
								<ErrorOutlineIcon />
							</CardIcon>
						</CardHeader>
						<CardBody>
							<GridContainer
								className={this.props.classes.header}
								container
								direction="row"
								justify="flex-end"
								alignItems="center"
							>
								<GridItem>
									<Button
										className={this.props.classes.refreshButton}
										color="transparent"
										justIcon
										aria-label="Alerts"
										aria-haspopup="true"
										onClick={this.fetchData}
									>
										<RefreshIcon />
									</Button>
								</GridItem>
							</GridContainer>
							<GridContainer>
								<GridItem className={this.props.classes.body} xs={12} sm={12} md={12}>
									{preloader}
									{emptyMessage}
									{!this.state.loading && (
										<div>
											{
												this.state.items.map((item) => (
													<AlertsItem
														key={item.id}
														{...item}
														markAlert={this.markAlert}
													/>
												))
											}
										</div>
									)}
								</GridItem>
							</GridContainer>
							<GridContainer
								container
								display="flex"
								direction="row"
								justify="flex-end"
								alignItems="center"
							>
								<GridItem xs={12} md={2}>
									<PageSizeSelect
										pageSize={this.props.rowsPerPage}
										setPageSize={this.setRowsPerPage}
									/>
								</GridItem>
								<Pagination
									count={this.state.pageCount}
									page={this.state.pageIndex}
									siblingCount={0}
									onChange={this.paginationHandler}
								/>
							</GridContainer>
						</CardBody>
					</Card>
				</GridItem>
			</GridContainer>
		);
	}
}

const mapStateToProps = ({
	settings: { rowsPerPage },
	auth: { auth },
}) => {
	return {
		rowsPerPage: rowsPerPage.alerts,
		userId: (auth || {}).id,
	};
};

const mapDispatchToProps = (dispatch) => ({
	setPageHeaderText: bindActionCreators(
		setPageHeaderTextActionCreator,
		dispatch),
	setRowsPerPage: bindActionCreators(
		setNumberRowsPerPageActionCreator,
		dispatch
	),
});

export default compose(
	withEvents,
	withRouter,
	withStyles(styles),
	connect(mapStateToProps, mapDispatchToProps)
)(Alerts);
